import { gql } from '@apollo/client'
import { CUBE_DIMENSIONS } from './CubeDimensions'
import { IDEAL_DISPLAY_INVENTORY_FACING_FRAGMENT } from './IdealInventoryFacingFragment'
import { SHELF_SCAN_FRAGMENT } from './ShelfScanFragment'

export const WHOLE_DISPLAY_FRAGMENT = gql`
  fragment WholeDisplay on Display {
    id
    qrId
    name
    shortDescription
    displayType
    extraInfo
    saved
    isCompetitor
    salesVolume
    images {
      id
      url
    }
    area
    numCoolerDoors
    doorHandlePlacement
    idealInventory {
      upcs
    }
    dateRemoved
    point {
      latitude
      longitude
    }
    boundingCubes {
      ...CubeDimensions
    }
    lastScan {
      id
      created
      complianceScore {
        score
      }
      planogram {
        segments {
          shelves {
            idealInventory {
              ...IdealDisplayInventoryFacing
            }
          }
        }
      }
      scans {
        shelfScans {
          ...ShelfScan
        }
        keyframes
      }
    }
  }
  ${SHELF_SCAN_FRAGMENT}
  ${IDEAL_DISPLAY_INVENTORY_FACING_FRAGMENT}
  ${CUBE_DIMENSIONS}
`
